import React from 'react';
import Layout from '@/common/Layout';
import FAQs from './components/';

const index = () => {
  return (
    <>
      <Layout
        // sider={true}
        hideHeader={true}
      >
        <FAQs />
      </Layout>
    </>
  );
};

export default index;
